import { filter, prop, symmetricDifference } from 'ramda';
import moment from 'moment';

import { originalTypes } from '../../../enums/stopTypes';
import { defaultOrderFn } from '../../../features/routeDetail/model';
import { isBreakStop } from '../../../models/stop';

export const isButtonsEnabled = (criteria) =>
  criteria.some(({ value }) => value);

const getCriteriaId = () => Date.now().toString(16);

export const getDefaultCriteriaItem = () => ({
  id: getCriteriaId(),
  rule: 'include',
});

export const formatTimeString = (value, timeFormat = 'HH:mm') =>
  typeof value === 'string'
    ? moment(value).format(timeFormat)
    : value.format(timeFormat);

export const getStopTypeOptions = (route) => {
  const options = new Set();
  const stops = route?.stop || [];
  const stopTypesMapped = {};

  Object.values(originalTypes).forEach(
    ({ stopType, stopTypeDescription }) =>
      (stopTypesMapped[stopType] = stopTypeDescription)
  );

  const filteredStops = stops.filter((stop) => !isBreakStop(stop));

  filteredStops.forEach(({ stopType }) => {
    options.add(stopType);
  });

  return [...options]
    .map((value) => ({ label: stopTypesMapped[value], value }))
    .sort((previous, next) => defaultOrderFn(previous, next, 'label'));
};

export const getStopTypeDefault = (route) =>
  getStopTypeOptions(route)[0]?.value;

export const getCriteriaDiff = (a, b) =>
  filter(prop('criteria'), symmetricDifference(a, b));
